<template>
    <v-scale-transition>
        <v-card :color="backgroundColor" max-width="400" elevation="10">
            <v-card-text>

                <div class="text-center">
                    <v-icon v-if="type === 'error'" size="100" color="red">mdi-alert</v-icon>
                    <v-icon v-if="type === 'info'" size="75" color="blue">mdi-information</v-icon>
                </div>
                <div :class="textClasses">
                    <slot></slot>
                </div>

            </v-card-text>
        </v-card>

    </v-scale-transition>
</template>

<script>

import colorMixin from "@/components/mixins/colorMixin.js";

export default {

    mixins: [colorMixin],

    props: {
        type: {
            type: String,
            required: false,
            default: 'error'
        }
    },

    data() {
        return {
            backgroundColor: '#FFFFFF'
        }
    },

    computed: {
        textClasses() {
            return ['pa-4 text-center', this.getFontClasses(this.backgroundColor)].join(' ');
        }
    },
}
</script>
